import React from 'react';
import PlayMedia from '~/core/components/PlayMedia'
import { Link } from 'react-router-dom'

const SingleColunn = ( props ) => {
	const { article } = props;
	return (
  <div className="section" key={article.nid}>
    <div className="news-article">
      <div className="image"  style={{ backgroundImage: 'url( //jeff.4zzz.org.au/' + article.field_news_image + ')', paddingTop: 'calc(100% * 0.6666)', backgroundPosition: 'bottom', backgroundSize: 'cover' }}>
        <PlayMedia media={'//jeff.4zzz.org.au/' + article.field_news_package_file} title={article.title} />
      </div>
      <div className="synopsis">
				<div className="category">{ article.live_content === 'true' ? <span style={{color: 'red', fontWeight: 600}}>Live </span> : null }{article.taxonomy_vocabulary_2}</div>
        <h2><Link to={article.path}>{article.title}</Link></h2>
        <div dangerouslySetInnerHTML={ { __html: article.body_1 } } />
        <div className="clear" />
      </div>
    </div>
  </div>
)}


export default SingleColunn;
